import React, {useRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import moment from "moment";
import {withStyles} from "@material-ui/core/styles";
import DataGrid from "../../../controls/DataGrid";

import { useAircraftMaintenanceList } from "../../../services/aircraft";

const styles = {
  header: {
    "&.ag-header-cell": {
      paddingLeft: 8, paddingRight: 8, fontSize: 12
    }
  },
  column: {
    "&.ag-cell-not-inline-editing": {
      paddingLeft:8, paddingRight: 8
    }
  },
};

const AircraftMaintenanceList = (_props) => {
  const {isAuthenticated} = useAuth0();

  const props = {
    ..._props
  }
  const { classes } = props;

  const [state, setState] = useState({
    canEdit: props.canEdit||false,
  });

  const dataGridRef = useRef();

  const queryClient = useQueryClient();
  const extraKeys = [props.aircraftTailNumber];

  const aircraftMaintenance = useAircraftMaintenanceList({queryClient, extraKeys});
  //console.log(aircraftMovements);

  const getColumns = (props) => {
    const baseColumn = {
      options: {
        cellClass: classes.column,
        headerClass: classes.header,
        menuTabs: [],
      },
      editable: props.canEdit,
    };

    return [
      {
        ...baseColumn,
        headerName: "Check",
        field: "aircraftCheck",
        width: 100,
      },
      {
        ...baseColumn,
        headerName: "Due In (Hours)",
        field: "hoursRemaining",
        width: 140,
        type: "numericColumn",
        valueFormatter: (params)=> {
          return params.value ? params.value.toLocaleString() : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Due In (Cycles)",
        field: "cyclesRemaining",
        width: 140,
        type: "numericColumn",
        valueFormatter: (params)=> {
          return params.value ? params.value.toLocaleString() : "";
        }
      },
      {
        ...baseColumn,
        headerName: "From Date",
        field: "fromDateUTC",
        width: 160,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY HH:mm") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Latest Due Date",
        field: "latestDueDate",
        width: 140,
        valueFormatter: (params)=> {
          return params.value ? moment.utc(params.value).format("DD/MM/YYYY") : "";
        }
      },
      {
        ...baseColumn,
        headerName: "Details",
        field: "details",
        //width: 400,
        flex: 1,
        autoHeight: true,
        wrapText: true
      },
      // {
      //   ...baseColumn,
      //   headerName: "Origin",
      //   field: "auditText",
      //   options: {
      //     ...baseColumn.options,
      //     flex: 1
      //   }
      // },
    ];
  };

  return (isAuthenticated &&
    <div style={{width: props.width?props.width:"100%", ...props.style}}>
      <DataGrid
        title="AircraftMaintenance"
        ref={dataGridRef}
        columns={getColumns({canEdit: state.canEdit})}
        rows={aircraftMaintenance.data}
        height={props.height||"300px"}
        options={{
          singleClickEdit: true,
          editType:'fullRow',
          onCellValueChanged: ()=>{}, //prevent default onCellValueChanged
          defaultColDef: {
            editable: false,
            resizable: false,
          }
        }}
      />
    </div>
  );

}

export default withStyles(styles)(AircraftMaintenanceList);
